<template>
    <div>
        <Toolbar>
            <BackButton :to="`${__('general.subscription')}: ${subscription.subscribable.lang.name}`"
                        :href="$route('subscriptions')"/>
        </Toolbar>

        <Card>
            <template v-slot:icon>
                <i class="fas fa-exclamation-triangle text-warning" style="font-size: inherit;" />
            </template>
            <template v-slot:title>
                {{ __('actions.end_thing', {thing: __('general.subscription')}) }}
            </template>
            <template v-slot:description>
                {{ subscription.subscribable.lang.name }}
            </template>

            <div class="d-flex flex-column gap-10">
                <div>
                    <div class="mb-1">
                        {{ __('subscriptions.cancel.confirm') }}
                    </div>
                    <div class="border border-dotted rounded p-5">
                        <Productable :productable="subscription.subscribable"/>
                    </div>
                </div>

                <div>
                    <div class="mb-1">
                        {{ __('subscriptions.cancel.lose') }}
                    </div>
                    <FeaturesTable :features="subscription.features" plain hide-header/>
                </div>

<!--                <div>-->
<!--                    <div class="mb-1">-->
<!--                        {{ __('subscriptions.end_date') }}-->
<!--                    </div>-->
<!--                    <div>...</div>-->
<!--                </div>-->

                <div>
                    <Checkbox type="danger" v-model="actionConfirmed">
                        {{ __('general.understood_and_continue') }}
                    </Checkbox>
                </div>
            </div>

            <template v-slot:footer>
                <Link as="button"
                      class="btn btn-danger"
                      :href="$route('subscriptions.cancel', subscription.id)"
                      method="DELETE"
                      :class="{'pointer-events-none opacity-50': !actionConfirmed}"
                >
                    <i class="fas fa-ban mr-1"/>
                    {{ __('actions.end_thing', {thing: __('general.subscription')}) }}
                </Link>
            </template>
        </Card>
    </div>
</template>

<script>
import Card from "@components/Cards/Card.vue";
import Toolbar from "@components/Toolbar.vue";
import BackButton from "@components/BackButton.vue";
import { Link } from '@inertiajs/vue2';
import Productable from "@components/Subscriptions/Productable.vue";
import FeaturesTable from "@components/Subscriptions/Features/FeaturesTable.vue";
import Checkbox from "@components/Form/Checkbox.vue";

export default {
    components: {Checkbox, FeaturesTable, Productable, BackButton, Toolbar, Card, Link},

    props: {
        subscription: Object,
        user: Object
    },

    data() {
        return {
            actionConfirmed: false
        }
    }
}
</script>
